import { 
    REQUEST_GALLERY_FETCH_EM,
    FETCH_GALLERY_EM_SUCCESS,
    FETCH_GALLERY_EM_FAILURE,
    CLEAR_FETCH_GALLERY_EM_STATES
} from './gallery.types';

let initialState = {
    reload: false,
    response : {},
    error : null,
    loading : false
}

const fetchGalleryEmReducer = (state = initialState, action) => {

    switch(action.type) {
        case REQUEST_GALLERY_FETCH_EM :
            return {
                ...state,
                loading: true,
                error: null
            }

        case FETCH_GALLERY_EM_SUCCESS:
            return {
                ...state,
                loading : false,
                response : action.payload,
                reload: false
            }

        case FETCH_GALLERY_EM_FAILURE:
            return {
                ...state,
                loading : false,
                error : action.payload,
                reload: false
            }
        
        case CLEAR_FETCH_GALLERY_EM_STATES:
            return {
                ...state,
                loading : false,
                response : {},
                error : null,
                reload: false
            }

        default:
            return state;
    }
}

export default fetchGalleryEmReducer